import { netural400, neturalBlack } from "../../constants/color";

const EmptyListPlaceholder = ({ title, subtitle }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "48px 20px",
      }}
    >
      <label
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: neturalBlack,
        }}
      >
        {title}
      </label>
      {subtitle && (
        <label
          style={{
            fontSize: "14px",
            color: netural400,
            textAlign: "center",
            marginTop: "8px",
            maxWidth: "400px",
          }}
        >
          {subtitle}
        </label>
      )}
    </div>
  );
};

export default EmptyListPlaceholder;
